import React, { Fragment } from 'react';

// VALIDATION ERRORS
export const APPLICANT_LEVEL_MISSING_ERROR = {
  param: "applicantLevel",
  message: "Your applicant level"
};
export const APPLICANT_LEVEL_INVALID_ERROR = {
  param: "applicantLevel",
  message: "Applicant level should be a number"
};
export const CAMPUS_MISSING_ERROR = {
  param: "campus",
  message: "At least one UC campus"
};

export const CAMPUS_INVALID_ERROR = {
  param: "campus",
  message: "Campuses should be an array of IDs"
};

export const TERMS_MISSING_ERROR = {
  param: "term",
  message: "Your application term (when you plan on starting UC)"
};
export const TERMS_INVALID_ERROR = {
  param: "term",
  message: "Terms should be an array of IDs"
};

export const MAJOR_NAME_INVALID_ERROR = {
  param: "major",
  message: "Major name must be a string"
};

export const CATEGORY_INVALID_ERROR = {
  param: "category",
  message: "Category must be a number"
};

export const SHOW_CLOSED_INVALID_ERROR = {
  param: "closed",
  message: "Show closed must be a boolean"
};

// SERVER ERRORS
export const GENERIC_NETWORK_ERROR = <Fragment>We’re sorry, but it looks like there’s an issue on our end. Please check again at a later time or you can
  <a
    target="_blank"
    href="https://apply.universityofcalifornia.edu"
    rel="noopener noreferrer"
  > sign in to the UC application </a>
  for the most up-to-date major information.
  </Fragment>;

export const BACKEND_VALIDATION_ERROR = 'Invalid search parameters.';

